import { render, staticRenderFns } from "./rosterspotOffroster.vue?vue&type=template&id=2e6a100e&scoped=true"
import script from "./rosterspotOffroster.vue?vue&type=script&lang=js"
export * from "./rosterspotOffroster.vue?vue&type=script&lang=js"
import style0 from "./rosterspotOffroster.vue?vue&type=style&index=0&id=2e6a100e&prod&lang=css"
import style1 from "./rosterspotOffroster.vue?vue&type=style&index=1&id=2e6a100e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6a100e",
  null
  
)

export default component.exports